import React from 'react';
import { TransactionDetailsModalView } from './View';
export var TransactionDetailsModalContainer = function (_a) {
    var details = _a.details, onEdit = _a.onEdit;
    return (React.createElement(TransactionDetailsModalView, { loading: false, processing: false, details: details, onEdit: onEdit }));
};
